// import React from "react";
import React, { useContext, createContext, useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import DataContext from "./DataContext";
import { useAuth } from "../auth/AuthState";
import {
  GetUserCommunityServer,
  GetActivityData,
  GetScoreData,
  GetUserPerosnalData,
} from "../../backendRequests/functionUtils";

const convertDateKeysToObject = (obj) => {
  const newObj = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (Array.isArray(obj[key])) {
        // If the value is an array, process each element separately
        newObj[key] = obj[key].map((element) => {
          if (
            typeof element === "object" &&
            element !== null &&
            !(element instanceof Date)
          ) {
            // If the element is an object (excluding Date objects), recursively process it
            return convertDateKeysToObject(element);
          } else if (element instanceof Date) {
            // If the element is a Date object, keep it as is
            return element;
          } else {
            // Otherwise, keep the element as is
            return element;
          }
        });
      } else if (
        typeof obj[key] === "object" &&
        obj[key] !== null &&
        !(obj[key] instanceof Date)
      ) {
        // If the value is an object (excluding Date objects), recursively process it
        newObj[key] = convertDateKeysToObject(obj[key]);
      } else {
        if (key.endsWith("date")) {
          // If the key ends with 'date', convert the value to a Date object
          newObj[key] = new Date(obj[key]);
        } else {
          // Otherwise, keep the value as is
          newObj[key] = obj[key];
        }
      }
    }
  }
  return newObj;
};

const DataState = (props) => {
  const [userPersonalData, setuserPersonalData] = useState({});
  const [date, setdate] = useState("");
  const [editFlag, seteditFlag] = useState(false);
  const [activityNo, setactivityNo] = useState(null);
  const [activityId, setactivityId] = useState("");
  const [communityId, setCommunityId] = useState(localStorage.getItem("communityId") || "");
  const [seasonId, setSeasonId] = useState(localStorage.getItem("seasonId") || -1);
  const [challengeId, setChallengeId] = useState(localStorage.getItem("challengeId") || -1);
  const [formattedDate, setformattedDate] = useState(new Date());
  const [activityTrackerData, setActivityTrackerData] = useState({});
  const [challengeTrackerData, setChallengeTrackerData] = useState({});
  const [seasonTrackerData, setSeasonTrackerData] = useState({});
  const { currentUser, userExist } = useAuth();
  const invalidDataURL = ["/signup"];


  const [data, setdata] = useState(0);
  console.log({ data });

  const updateIdsBasedOnDate = (
    currentSeasonId = seasonId,
    currentChallengeId = challengeId
  ) => {
    const currentDate = new Date();

    const updatedData = { ...data }; // Creating a copy of the data object

    if (!updatedData.community) {
      return;
    }

    if (updatedData.community[communityId] === undefined) {
      setCommunityId(Object.keys(updatedData.community)[0]);
      return;
    }

    // Check and update seasonId
    if (
      currentSeasonId === "-1" ||
      currentSeasonId === -1 ||
      !Object.keys(updatedData.community[communityId].season).includes(seasonId)
    ) {
      const seasonIds = Object.keys(updatedData.community[communityId].season);
      let closestSeasonId = seasonIds[0];

      for (let i = 1; i < seasonIds.length; i++) {
        const currentSeason =
          updatedData.community[communityId].season[seasonIds[i]];
        const startDate = new Date(currentSeason.start_date);
        const endDate = new Date(currentSeason.end_date);

        if (startDate <= currentDate && currentDate <= endDate) {
          setSeasonId(seasonIds[i]);
          return; // Stop iterating if current date is within a season
        }

        const closestStartDate = new Date(
          updatedData.community[communityId].season[closestSeasonId].start_date
        );
        const closestEndDate = new Date(
          updatedData.community[communityId].season[closestSeasonId].end_date
        );

        if (
          Math.abs(currentDate - startDate) <
          Math.abs(currentDate - closestStartDate) &&
          Math.abs(currentDate - endDate) <
          Math.abs(currentDate - closestEndDate)
        ) {
          closestSeasonId = seasonIds[i];
        }
      }
      currentSeasonId = closestSeasonId;
      setSeasonId(closestSeasonId);
    }

    // Check and update challengeId
    if (
      currentSeasonId !== "-1" &&
      currentSeasonId !== -1 &&
      currentSeasonId &&
      Object.keys(updatedData.community[communityId].season || {}).includes(
        currentSeasonId
      ) &&
      (currentChallengeId === "-1" ||
        currentChallengeId === -1 ||
        !currentChallengeId ||
        !Object.keys(
          updatedData.community[communityId].season[currentSeasonId]
            .challenge || {}
        ).includes(currentChallengeId))
    ) {
      const challengeIds = Object.keys(
        updatedData.community[communityId].season[currentSeasonId].challenge ||
        {}
      );
      let closestChallengeId = challengeIds[0];

      for (let i = 1; i < challengeIds.length; i++) {
        const currentChallenge =
          updatedData.community[communityId].season[currentSeasonId].challenge[
          challengeIds[i]
          ];
        const startDate = new Date(currentChallenge.start_date);
        const endDate = new Date(currentChallenge.end_date);

        if (startDate <= currentDate && currentDate <= endDate) {
          setChallengeId(challengeIds[i]);

          // Check and update the date according to the challenge date range
          const challengeStartDate = new Date(currentChallenge.start_date);
          const challengeEndDate = new Date(currentChallenge.end_date);

          if (
            date === "" ||
            challengeStartDate > new Date(date) ||
            new Date(date) > challengeEndDate
          ) {
            // Set the date to today's date if it's within the challenge range,
            // otherwise set it to the last date in the range
            const newDate =
              currentDate <= challengeEndDate
                ? currentDate.toISOString().split("T")[0]
                : challengeEndDate.toISOString().split("T")[0];

            setdate(newDate);
          }

          return; // Stop iterating if current date is within a challenge
        }

        const closestStartDate = new Date(
          updatedData.community[communityId].season[currentSeasonId].challenge[
            closestChallengeId
          ].start_date
        );
        const closestEndDate = new Date(
          updatedData.community[communityId].season[currentSeasonId].challenge[
            closestChallengeId
          ].end_date
        );

        if (
          Math.abs(currentDate - startDate) <
          Math.abs(currentDate - closestStartDate) &&
          Math.abs(currentDate - endDate) <
          Math.abs(currentDate - closestEndDate)
        ) {
          closestChallengeId = challengeIds[i];
        }
      }

      // Set the date according to the challenge date range
      const closestChallenge =
        updatedData.community[communityId].season[currentSeasonId].challenge[
        closestChallengeId
        ];
      if (!closestChallenge) {
        return;
      }
      const closestChallengeStartDate = new Date(closestChallenge.start_date);
      const closestChallengeEndDate = new Date(closestChallenge.end_date);

      if (
        date === "" ||
        closestChallengeStartDate > new Date(date) ||
        new Date(date) > closestChallengeEndDate
      ) {
        // Set the date to today's date if it's within the challenge range,
        // otherwise set it to the last date in the range
        const newDate =
          currentDate <= closestChallengeEndDate
            ? currentDate.toISOString().split("T")[0]
            : closestChallengeEndDate.toISOString().split("T")[0];

        setdate(newDate);
      }

      currentChallengeId = closestChallengeId;
      setChallengeId(closestChallengeId);
    } else if (
      currentSeasonId !== "-1" &&
      currentSeasonId !== -1 &&
      currentSeasonId &&
      Object.keys(updatedData.community[communityId].season || {}).includes(
        currentSeasonId
      ) &&
      currentChallengeId !== "-1" &&
      currentChallengeId !== -1 &&
      currentChallengeId &&
      Object.keys(
        updatedData.community[communityId].season[currentSeasonId].challenge ||
        {}
      ).includes(currentChallengeId)
    ) {
      // No new challenge ID set, check and update the date if needed
      const currentChallenge =
        updatedData.community[communityId].season[currentSeasonId].challenge[
        currentChallengeId
        ];

      if (currentChallenge) {
        // Check and update the date according to the challenge date range
        const challengeStartDate = new Date(currentChallenge.start_date);
        const challengeEndDate = new Date(currentChallenge.end_date);

        if (
          date === "" ||
          challengeStartDate > new Date(date) ||
          new Date(date) > challengeEndDate
        ) {
          // Set the date to today's date if it's within the challenge range,
          // otherwise set it to the last date in the range
          const newDate =
            currentDate <= challengeEndDate
              ? currentDate.toISOString().split("T")[0]
              : challengeEndDate.toISOString().split("T")[0];

          setdate(newDate);
        }
      }
    }
  };

  // Call the function to update the IDs
  useEffect(() => {
    updateIdsBasedOnDate();
  }, [data, communityId, seasonId, challengeId]);

  // Persist IDs to localStorage
  useEffect(() => {
    if (communityId) localStorage.setItem("communityId", communityId);
  }, [communityId]);

  useEffect(() => {
    if (seasonId && seasonId !== -1 && seasonId !== "-1") localStorage.setItem("seasonId", seasonId);
  }, [seasonId]);

  useEffect(() => {
    if (challengeId && challengeId !== -1 && challengeId !== "-1") localStorage.setItem("challengeId", challengeId);
  }, [challengeId]);

  const updateData = async () => {
    try {
      let new_data = {
        community: await GetUserCommunityServer(currentUser.user_id),
      };
      new_data = convertDateKeysToObject(new_data);
      setdata(new_data);
    } catch (err) {
      if (data === 0) setdata(1);
      console.error(err);
    }
  };

  const updateUserPersonalData = async () => {
    if (!currentUser) {
      setuserPersonalData({});
      return;
    }
    try {
      let new_data = await GetUserPerosnalData(currentUser.user_id);
      setuserPersonalData(new_data);
    } catch (err) {
      console.error(err);
    }
  };

  const updateTrackerData = async (idType, id) => {
    if (idType === "season" && id !== -1 && id !== "-1" && id) {
      const newData = await GetScoreData({ season_id: id });
      if (newData) setSeasonTrackerData(newData);
    } else if (idType === "challenge" && id !== -1 && id !== "-1" && id) {
      const newData = await GetScoreData({ challenge_id: id });
      if (newData) setChallengeTrackerData(newData);
    } else if (idType === "activity" && id !== -1 && id !== "-1" && id) {
      const newData = await GetScoreData({ activity_id: id });
      if (newData) setActivityTrackerData(newData);
    }
  };

  useEffect(() => {
    if (
      seasonId !== -1 &&
      seasonId !== "-1" &&
      seasonId !== undefined &&
      seasonId !== null
    ) {
      updateTrackerData("season", seasonId);
    }
  }, [seasonId]);

  useEffect(() => {
    if (
      challengeId !== -1 &&
      challengeId !== "-1" &&
      challengeId !== undefined &&
      challengeId !== null
    ) {
      updateTrackerData("challenge", challengeId);
    }
  }, [challengeId]);

  useEffect(() => {
    if (
      activityId !== -1 &&
      activityId !== "-1" &&
      activityId !== undefined &&
      activityId !== null
    ) {
      updateTrackerData("activity", activityId);
    }
  }, [activityId]);

  useEffect(() => {
    if (currentUser && userExist) {
      updateData();
      updateUserPersonalData();
    }
  }, [currentUser, userExist]);

  useEffect(() => {
    if (currentUser && activityId) fetchActivityStatusData();
  }, [activityId, currentUser]);

  const changeSeasonId = (newSeasonId) => {
    setSeasonId(newSeasonId);
  };

  const changeCommunityId = (newSeasonId) => {
    setCommunityId(newSeasonId);
  };

  const [activityStatusData, setActivityStatusData] = useState([]);

  const fetchActivityStatusData = async () => {
    try {
      let new_data = await GetActivityData({
        user_id: currentUser.user_id,
        activity_id: activityId,
      });
      setActivityStatusData(new_data);
    } catch (err) {
      console.error(err);
    }
  };

  const value = {
    userPersonalData,
    updateUserPersonalData,
    data,
    updateData,
    date,
    setdate,
    communityId,
    changeCommunityId,
    seasonId,
    changeSeasonId,
    activityNo,
    setactivityNo,
    activityId,
    setactivityId,
    challengeId,
    setChallengeId,
    editFlag,
    seteditFlag,
    activityStatusData,
    setActivityStatusData,
    fetchActivityStatusData,
    formattedDate,
    setformattedDate,
    activityTrackerData,
    challengeTrackerData,
    seasonTrackerData,
    updateTrackerData,
  };

  return (
    <DataContext.Provider value={value}>{props.children}</DataContext.Provider>
  );
};

export function useData() {
  return useContext(DataContext);
}

export default DataState;
